const URL = 'https://api.fcms.pl/';
//const URL = process.env.NODE_ENV === 'production' ? 'https://api.bookradio.pl/' : 'http://localhost:21021/';
//const URL = 'http://localhost:21021/';
export default URL;